// extracted by mini-css-extract-plugin
export default {"wrap":"uG-z","articleImagesWrap":"vG-z","articleImage":"wG-z","singleImage":"xG-z"};